// extracted by mini-css-extract-plugin
export var home_page = "HomeContainer-module--home_page--uT2t2";